var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMapSideBarVisible)?_c('map-sidebar-overlay',{attrs:{"isLoading":_vm.isLoading,"uuid":_vm.uuid,"mapFullInfo":_vm.mapFullInfo},on:{"emitCancelAction":_vm.closeSidebar}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }